import { BasicSeries } from '../../../types/deal.types';
import {
  SeriesValueGetter,
  ValueGetterParamsWithSeries
} from './value-getters.interface';
import { isDefined } from '../../../utils/utils';

export function seriesValueGetter(field: string): SeriesValueGetter {
  return ({ data }: ValueGetterParamsWithSeries) => {
    if (!isDefined(data)) {
      return [];
    }
    if (data.series) {
      return getReducedSeries(data, field);
    } else {
      return [];
    }
  };
}

function getReducedSeries(data, field) {
  return data.series.reduce((acc: string[], series: BasicSeries) => {
    const value: string[] = series[field];

    if (Array.isArray(value)) {
      value.forEach((val: string) => {
        if (acc.indexOf(val) === -1) {
          acc.push(val);
        }
      });
    } else {
      if (acc.indexOf(value) === -1) {
        acc.push(value);
      }
    }
    return acc;
  }, []);
}
